// Espelha server/lib/roles.ts. Ficam nos dois lados para manter tipagem no
// frontend sem forçar import cruzado.
export const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  OPERADOR: 'OPERADOR',
  MOTORISTA: 'MOTORISTA'
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];

export const COMPANY_ROLES: Role[] = [
  ROLES.ADMIN,
  ROLES.MANAGER,
  ROLES.OPERADOR,
  ROLES.MOTORISTA
];

export const ROLE_LABEL: Record<Role, string> = {
  SUPER_ADMIN: 'Super admin',
  ADMIN: 'Administrador',
  MANAGER: 'Gerente',
  OPERADOR: 'Operador',
  MOTORISTA: 'Motorista'
};

export const ROLE_DESC: Record<Role, string> = {
  SUPER_ADMIN: 'Enxerga e opera todas as empresas do SaaS.',
  ADMIN: 'Configura a empresa, gerencia usuários, vê tudo.',
  MANAGER: 'Opera rotas, frota e BI. Não gerencia usuários.',
  OPERADOR: 'Cadastra pontos, monta e edita rotas.',
  MOTORISTA: 'Vê apenas as rotas atribuídas no Modo Motorista.'
};
